import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore from './store/configureStore';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import firebase from 'firebase/app';
import 'firebase/analytics';
import { PersistGate } from 'redux-persist/es/integration/react';
import Entrypoint from './Entrypoint';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import ScrollToTop from './components/ScrollToTop';
import SnackbarContainer from './components/SnackbarContainer/SnackbarContainer';

const { persistor, store } = configureStore();
// Or Create your Own theme:
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#075FDC',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#ef7f27',
      contrastText: '#FFFFFF'
    }
  }
});

const firebaseConfig = {
  apiKey: 'AIzaSyCSiHRIwIL-mU3tU2_Pao9FmZnsv-aFVRg',
  authDomain: 'allen-digital-b1a68.firebaseapp.com',
  databaseURL: 'https://allen-digital-b1a68.firebaseio.com',
  projectId: 'allen-digital-b1a68',
  storageBucket: 'allen-digital-b1a68.appspot.com',
  messagingSenderId: '841645685590',
  appId: '1:841645685590:web:79d6bb10d1758d7cc9f4f7',
  measurementId: 'G-N9PETZXHBT'
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

render(
  <MuiThemeProvider theme={theme}>
    <AppContainer>
      <BrowserRouter>
        <ScrollToTop />
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <SnackbarContainer />
            <Entrypoint />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </AppContainer>
  </MuiThemeProvider>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./Entrypoint', () => {
    const NewEntrypoint = require('./Entrypoint').default;
    render(
      <AppContainer>
        <BrowserRouter>
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <NewEntrypoint />
            </PersistGate>
          </Provider>
        </BrowserRouter>
      </AppContainer>,
      document.getElementById('app')
    );
  });
}
